/**
 * 线索常量定义
 */

// ==================== 数据来源 ====================
export const DATA_SOURCE_OPTIONS = [
  { label: '抖音', value: '抖音' },
  { label: '抖音直播', value: '抖音直播' },
  { label: '大众', value: '大众' },
  { label: '美团', value: '美团' },
  { label: '百度', value: '百度' },
  { label: '高德', value: '高德' },
  { label: '高德推广', value: '高德推广' },
  { label: '华律', value: '华律' },
  { label: '律图', value: '律图' },
  { label: '转介绍', value: '转介绍' },
  { label: '小红书', value: '小红书' },
  { label: '自然流量', value: '自然流量' },
  { label: '渠道TJ', value: '渠道TJ' },
  { label: '其他', value: '其他' },
];

// ==================== 线索类型 ====================
export const LEAD_TYPE_OPTIONS = [
  { label: '经济', value: '经济' },
  { label: '合同', value: '合同' },
  { label: '婚姻', value: '婚姻' },
  { label: '继承', value: '继承' },
  { label: '工伤', value: '工伤' },
  { label: '人损', value: '人损' },
  { label: '劳动', value: '劳动' },
  { label: '法顾', value: '法顾' },
  { label: '非诉业务', value: '非诉业务' },
  { label: '刑事辩护', value: '刑事辩护' },
  { label: '刑事会见', value: '刑事会见' },
  { label: '其他', value: '其他' },
];

// ==================== 跟进意向 ====================
export const FOLLOW_STATUS_OPTIONS = [
  // 初始状态
  { value: '未联系', label: '未联系', color: '#d9d9d9' },

  // 联系中
  { value: '未接通', label: '未接通', color: '#faad14' },
  { value: '无人接听', label: '无人接听', color: '#faad14' },
  { value: '稍后联系', label: '稍后联系', color: '#1890ff' },

  // 无效线索
  { value: '不需要', label: '不需要', color: '#ff4d4f' },
  { value: '无效', label: '无效', color: '#ff4d4f' },
  { value: '空号', label: '空号', color: '#ff4d4f' },
  { value: '停机', label: '停机', color: '#ff4d4f' },
  { value: '重复', label: '重复', color: '#ff7a45' },
  { value: '客诉', label: '客诉', color: '#f5222d' },

  // 进展中
  { value: '已加微信', label: '已加微信', color: '#52c41a' },
  { value: '已加企微', label: '已加企微', color: '#13c2c2' },
  { value: '已付咨询费', label: '已付咨询费', color: '#52c41a' },
  { value: '邀约到所', label: '邀约到所', color: '#722ed1' },

  // 成交
  { value: '已成交', label: '已成交', color: '#389e0d' },
];

// 默认跟进意向
export const DEFAULT_FOLLOW_STATUS = '未联系';

// 获取跟进意向颜色
export const getFollowStatusColor = (followStatus: string): string => {
  const option = FOLLOW_STATUS_OPTIONS.find(opt => opt.value === followStatus);
  return option?.color || 'default';
};

// ==================== 紧急程度 ====================
export const URGENCY_LEVEL_OPTIONS = [
  { value: 'A类', label: 'A类', color: '#ff4d4f', description: '最高优先级' },
  { value: 'B类', label: 'B类', color: '#faad14', description: '高优先级' },
  { value: 'C类', label: 'C类', color: '#52c41a', description: '中优先级' },
  { value: 'D类', label: 'D类', color: '#1890ff', description: '低优先级' },
];

// 获取紧急程度颜色
export const getUrgencyLevelColor = (urgencyLevel: string): string => {
  const option = URGENCY_LEVEL_OPTIONS.find(opt => opt.value === urgencyLevel);
  return option?.color || 'default';
};
